<div style="padding-top: 81px; width: 75%; margin: auto;">
  <div class="title">
    <span style="color: #37474f; cursor: pointer;" (click)="onClickUser()">{{ "users" | translate }}</span>
    <span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span>
    <span style="font-weight: 700; color: var(--title-color);">{{ currUser.name }}</span>
  </div>
  <div style="float: right; margin-bottom: 16px;">
    <button *ngIf="!auth.isYakuin" class="edit-btn" (click)="onClickEdit()"> 
      {{ "edit" | translate }}
    </button> 
  </div>
  <div class="info-area">
    <div class="user-bg">
      <img 
        src="../../assets/images/user-bg.png" 
      />
    </div>
    <div class="user-info">
      <div class="user-info-top">
        <div class="user-profile-image">
          <img 
            src="../../assets/images/user-profile-image.png" 
          />
        </div>
        <div class="user-contact-info">
          <div class="contact-item">
            <div class="email-icon"></div>
            <div class="contact-txt">{{ currUser.email }}</div>
            <button
              class="items-center justify-center text-center font-inter cursor-pointer rounded copy-btn"
              *ngIf="currUser.email"
              (click)="copyItem(currUser.email, 'copyMsgEmail')"
            >
              {{"copy" | translate}}
            </button>
          </div>
          <div class="contact-item">
            <div class="telephone-icon"></div>
            <div class="contact-txt">{{ currUser.telephone }}</div>
            <button
              class="items-center justify-center text-center font-inter cursor-pointer rounded copy-btn"
              *ngIf="currUser.telephone"
              (click)="copyItem(currUser.telephone, 'copyMsgTelephone')"
            >
              {{"copy" | translate}}
            </button>
          </div>
          <div class="contact-item">
            <div class="fax-icon"></div>
            <div class="contact-txt">{{ currUser.fax }}</div>
            <button
              class="items-center justify-center text-center font-inter cursor-pointer rounded copy-btn"
              *ngIf="currUser.fax"
              (click)="copyItem(currUser.fax, 'copyMsgFax')"
            >
              {{"copy" | translate}}
            </button>
          </div>
        </div>
      </div>
      <div style="font-size: 20px; font-weight: 600; margin: 16px 0 8px 0;">{{ currUser.name }}</div>
      <div class="user-info-bottom">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 3.4c0-.22.179-.4.4-.4h13.2c.22 0 .4.18.4.4v13.2a.4.4 0 0 1-.4.4H3.4a.4.4 0 0 1-.4-.4V3.4zm.8 12.8V3.8h12.4v12.4H14V5.4a.4.4 0 0 0-.4-.4H6.4a.4.4 0 0 0-.4.4v10.8H3.8zm3-10c0-.22.179-.4.4-.4H8c.22 0 .4.18.4.4V7a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4v-.8zm0 2.4c0-.22.179-.4.4-.4H8c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4v-.8zm.4 2a.4.4 0 0 0-.4.4v.8c0 .22.179.4.4.4H8a.4.4 0 0 0 .4-.4V11a.4.4 0 0 0-.4-.4h-.8zm-.4 2.8c0-.22.179-.4.4-.4H8c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4v-.8zm2.8-7.6a.4.4 0 0 0-.4.4V7c0 .22.179.4.4.4h.8a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4h-.8zm-.4 2.8c0-.22.179-.4.4-.4h.8c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4h-.8a.4.4 0 0 1-.4-.4v-.8zm.4 2a.4.4 0 0 0-.4.4v.8c0 .22.179.4.4.4h.8a.4.4 0 0 0 .4-.4V11a.4.4 0 0 0-.4-.4h-.8zm-.4 2.8c0-.22.179-.4.4-.4h.8c.22 0 .4.18.4.4v1.933a.5.5 0 0 1-.5.5h-.6a.5.5 0 0 1-.5-.5V13.4zM12 5.8a.4.4 0 0 0-.4.4V7c0 .22.179.4.4.4h.8a.4.4 0 0 0 .4-.4v-.8a.4.4 0 0 0-.4-.4H12zm-.4 2.8c0-.22.179-.4.4-.4h.8c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H12a.4.4 0 0 1-.4-.4v-.8zm.4 2a.4.4 0 0 0-.4.4v.8c0 .22.179.4.4.4h.8a.4.4 0 0 0 .4-.4V11a.4.4 0 0 0-.4-.4H12zm-.4 2.8c0-.22.179-.4.4-.4h.8c.22 0 .4.18.4.4v.8a.4.4 0 0 1-.4.4H12a.4.4 0 0 1-.4-.4v-.8z" fill="#607D8B"/>
          </svg>
          <div class="detail-txt">{{ currCompany?.name }}</div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center;">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="6gbge2a09a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-3" y="-3" width="21" height="21">
                <path fill="#D9D9D9" d="M-2.965-2.966h20.929v20.929H-2.965z"/>
            </mask>
            <g mask="url(#6gbge2a09a)">
                <path d="M2.536 12.229H7.23v-.233a1.098 1.098 0 0 0-.617-.986 5.762 5.762 0 0 0-.85-.248 4.312 4.312 0 0 0-1.762 0 5.08 5.08 0 0 0-.85.258.989.989 0 0 0-.453.396 1.092 1.092 0 0 0-.163.58v.233zm7.573-1.08h2.107c.14 0 .261-.051.363-.153a.496.496 0 0 0 .153-.363.499.499 0 0 0-.153-.364.496.496 0 0 0-.364-.153H10.11c-.14 0-.262.05-.364.152a.496.496 0 0 0-.152.364c0 .14.05.261.152.364a.496.496 0 0 0 .364.153zm-5.23-1.033c.288 0 .534-.1.738-.302a.992.992 0 0 0 .306-.734c0-.288-.1-.534-.302-.738a.992.992 0 0 0-.734-.306c-.287 0-.533.101-.737.302a.993.993 0 0 0-.306.734c0 .288.1.534.302.738a.992.992 0 0 0 .734.306zm5.23-1.047h2.107c.14 0 .261-.05.363-.152a.496.496 0 0 0 .153-.363.499.499 0 0 0-.153-.364.497.497 0 0 0-.364-.154H10.11c-.14 0-.262.051-.364.153a.495.495 0 0 0-.152.363c0 .14.05.262.152.364a.496.496 0 0 0 .364.153zM1.234 15c-.353 0-.647-.117-.882-.352A1.197 1.197 0 0 1 0 13.765V5.42c0-.353.117-.647.352-.882s.529-.352.882-.352H6.28V.698c0-.192.068-.356.205-.493A.672.672 0 0 1 6.976 0h1.047c.192 0 .356.068.493.205.136.137.205.3.205.493v3.488h5.044c.353 0 .647.117.882.352s.352.529.352.882v8.345c0 .353-.117.647-.352.882a1.196 1.196 0 0 1-.882.352H1.235zm0-.697h12.53c.158 0 .286-.05.387-.151.1-.1.15-.23.15-.386V5.42a.523.523 0 0 0-.15-.386c-.1-.1-.23-.15-.386-.15H8.72v.67c0 .19-.07.354-.21.492a.674.674 0 0 1-.488.206H6.976a.67.67 0 0 1-.488-.21.67.67 0 0 1-.21-.488v-.67H1.235a.523.523 0 0 0-.385.15c-.101.101-.151.23-.151.386v8.345c0 .156.05.285.15.386.101.1.23.15.386.15zm5.742-8.748h1.047V.698H6.976v4.856z" fill="#607D8B"/>
            </g>
          </svg>
          <div class="detail-txt">{{ currUser.position }}</div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center;">
          <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="d352lkkr9a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-5" y="-3" width="22" height="21">
                <path fill="#D9D9D9" d="M-4.44-2.959h20.881v20.881H-4.44z"/>
            </mask>
            <g mask="url(#d352lkkr9a)">
                <path d="M6 14.053c1.592-1.35 2.874-2.751 3.846-4.201.972-1.45 1.458-2.713 1.458-3.787 0-1.533-.497-2.815-1.49-3.843C8.821 1.193 7.55.679 6 .679c-1.55 0-2.82.514-3.814 1.543C1.193 3.25.696 4.532.696 6.065c0 1.074.486 2.336 1.458 3.787.972 1.45 2.254 2.85 3.846 4.201zm0 .612a.941.941 0 0 1-.332-.056 1.326 1.326 0 0 1-.322-.185 24.717 24.717 0 0 1-1.263-1.14 20.441 20.441 0 0 1-1.797-1.962A13.577 13.577 0 0 1 .683 8.825C.228 7.915 0 6.995 0 6.065c0-1.608.545-3.021 1.635-4.239C2.725.61 4.18 0 6 0c1.806 0 3.257.609 4.354 1.826C11.452 3.044 12 4.456 12 6.066c0 .93-.231 1.85-.694 2.762a14.936 14.936 0 0 1-1.594 2.508c-.6.76-1.194 1.411-1.779 1.951a28.44 28.44 0 0 1-1.262 1.12c-.11.086-.219.151-.324.194a.91.91 0 0 1-.347.064zm.003-7.417c.344 0 .635-.12.872-.36.238-.239.357-.53.357-.874s-.12-.635-.36-.872a1.196 1.196 0 0 0-.875-.357c-.344 0-.634.12-.872.36s-.356.53-.356.875c0 .343.12.634.359.872.24.237.531.356.875.356z" fill="#607D8B"/>
            </g>
          </svg>
          <div class="detail-txt">{{ currUser.address }}</div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="tenant-field">
    <div class="tenant-label">{{'tenants' | translate}}</div>
    <div class="field-label">Current tenant access</div>
    <div class="tenant-value">
      {{ getCurrTenantName() }}
    </div>
    <div class="field-label" style="margin-top: -7px;">{{'role' | translate}}</div>
    <div class="tenant-value">{{ selectedRole?.name }}</div>
  </div>
</div>
